angular.
module("dx.webapp.printing").
directive("dxPrintSettings", function printSettingsDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			settings: "=",
			settingOptions: "<",
			sortOn: "=",
			sortOptions: "<",
			pageBreakBefore: "=",
			pageBreakOptions: "<",
			anonymous: "<",
			disabledStudentCodes: "<",
		},
		templateUrl: "tmpl/printing/print-settings-directive.html",
		controller: "dxPrintSettingsController",
		controllerAs: "vm",
		bindToController: true,
	};
});
